module.exports = __webpack_public_path__ + "static/img/banner_zyyw.945bfe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/mainBusiness/banner_zyyw.png
// module id = Opth
// module chunks = 0